import { useMutation, useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { SearchResponse } from "../Search/data";
import { AddCartParams, CartResponse, DeleteCartParams } from "./data";
import {
  apiAddToCart,
  apiDeleteFromCart,
  apiGetCartItems,
  apiGetCartStatus,
} from "./service";

export const useGetCartItems = (options: any) => {
  return useQuery<CartResponse>({
    queryKey: [queryKey.CART],
    queryFn: () =>
      apiGetCartItems().then((res: ApiResponse<CartResponse>) => {
        const items = res.data.data.order_items.map((order: SearchResponse) => {
          return { ...order, checked: false };
        });
        return { ...res.data.data, order_items: items };
      }),
    ...options,
  });
};

export const useAddToCart = () => {
  return useMutation({
    mutationFn: ({ params }: { params: AddCartParams }) => apiAddToCart(params),
  });
};

export const useDeleteFromCart = () => {
  return useMutation({
    mutationFn: ({ params }: { params: DeleteCartParams }) =>
      apiDeleteFromCart(params),
  });
};
export const useGetCartStatus = (options: any) => {
  return useQuery<boolean>({
    queryKey: [queryKey.CART_STATUS],
    queryFn: () =>
      apiGetCartStatus().then((res: ApiResponse<boolean>) => {
        return res.data.data;
      }),
    ...options,
  });
};
